/**
 * react-select / creatable option colors shared by bond retrieval and historic components.
 * Keeps Sonar S3358 nested-ternary out of inline `customStyles.option` handlers.
 */
export function retrievalCreatableOptionColors(state) {
  let backgroundColor = "#fff";
  if (state.isSelected) {
    backgroundColor = "#6200ea";
  } else if (state.isFocused) {
    backgroundColor = "#f0f0f0";
  }
  let color = "#000";
  if (state.isSelected) {
    color = "#fff";
  }
  return { backgroundColor, color };
}

/** Bond retrieval creatable select styles (matches MUI TextField). */
export const retrievalCreatableSelectStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    minHeight: "56px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      borderColor: "rgba(0, 0, 0, 0.87)",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "16px",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    ...retrievalCreatableOptionColors(state),
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  }),
};

/** Historic bond-creation creatable select styles (alias of retrieval styles). */
export const historicCreatableSelectStyles = retrievalCreatableSelectStyles;
